import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { SplitProgressBar } from "../../../components/SplitProgressBar";
import { getBillingCollectedFeePercentage } from "../../../selectors/billing";
import { formatPercentage } from "../../../utils/number";

import styles from "./BillingCollectedFeeProgressBar.module.scss";

export const BillingCollectedFeeProgressBar = () => {
  const { t } = useTranslation();
  const collectedFeePercentage = useSelector(getBillingCollectedFeePercentage);

  return (
    <div className={styles.container}>
      <p className={styles.label}>
        {t("billingCollectedFeeProgressBar.label")}{" "}
        <span className={styles.value}>{formatPercentage(collectedFeePercentage)}</span>
      </p>
      <SplitProgressBar
        showLabel={false}
        leftSegment={{ value: collectedFeePercentage, color: "var(--green)" }}
        rightSegment={{ value: 100 - collectedFeePercentage, color: "var(--gray-border)" }}
      />
    </div>
  );
};
